import PortalLayout from '../views/Layouts/PortalLayout';
import Firebase, { withFirebase, FirebaseContext } from './Firebase';

export { 
  FirebaseContext,
  withFirebase,
  PortalLayout,
};

export default Firebase;